import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { INSIGHTS } from "@/data/insights";

const Insights = () => {
  useEffect(() => {
    document.title = "Insights — Click World Online";
  }, []);
  return (
    <>
      <PageHeader
        eyebrow="Insights"
        title={<>Ideas that move <span className="text-electric">business forward.</span></>}
        text="Practical thinking on digital marketing, search, social media and online growth — written for businesses in Punjab and beyond."
      />
      <section data-testid="insights-list-section" className="bg-navy-deep">
        <div className="max-w-8xl mx-auto px-6 lg:px-12 py-20 lg:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {INSIGHTS.map((a, i) => (
              <Reveal key={a.slug} delay={0.06 * i}>
                <Link
                  to={`/insights/${a.slug}`}
                  data-testid={`insight-card-${a.slug}`}
                  className="group relative flex flex-col h-full bg-navy-light border border-white/10 rounded-3xl p-8 lg:p-12 overflow-hidden hover:border-electric/40 transition-colors duration-300 grain"
                >
                  <div className="absolute inset-0 dot-grid opacity-15" aria-hidden="true" />
                  <div className="absolute -top-20 -right-20 w-64 h-64 bg-brand/25 blur-[100px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" aria-hidden="true" />
                  <div className="relative flex flex-col h-full">
                    <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em]">
                      <span className="text-electric font-semibold">{a.category}</span>
                    </div>
                    <h2 className="mt-6 font-display text-2xl lg:text-4xl font-extrabold tracking-tight text-mist group-hover:text-electric transition-colors duration-300 leading-tight">
                      {a.title}
                    </h2>
                    <p className="mt-4 text-slatec leading-relaxed flex-1">{a.excerpt}</p>
                    <span className="mt-8 inline-flex items-center gap-2 text-electric font-semibold group-hover:gap-3 transition-[gap] duration-300">
                      Read the article <ArrowUpRight size={18} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
            <Reveal delay={0.1}>
              <div className="flex flex-col justify-center h-full border border-dashed border-white/15 rounded-3xl p-8 lg:p-12 text-center" data-testid="insights-more-card">
                <p className="font-display text-2xl lg:text-3xl font-extrabold tracking-tight text-mist/60">
                  More insights on the way.
                </p>
                <p className="mt-4 text-slatec text-sm leading-relaxed max-w-sm mx-auto">
                  We're publishing practical digital marketing thinking regularly. Follow us on social media to catch
                  new articles as they land.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
};

export default Insights;
